import React from 'react';

const Notification: React.FC = () => {
    return (
        <>
            <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="notificationlabel">Notifications</h5>
                <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div className="offcanvas-body">
                <div className="card mb-2">
                    <div className="card-body">
                        <div className="row gx-3">
                            <div className="col-auto">
                                <figure className="avatar avatar-30 coverimg rounded-circle">
                                    <img src={asset('assets/img/adminuiux/user-2.jpg')} alt="" />
                                </figure>
                            </div>
                            <div className="col">
                                <p className="small mb-2"><a href="adminux-profile-professional.html" className="text-theme-1 style-none">Alex Smith</a>, <a href="adminux-profile-professional.html" className="text-theme-1 style-none">John McMillan</a> and <span className="fw-medium">36 others</span> are also ordered from same website</p>

                                <div className="row gx-3 align-items-center">
                                    <div className="col">
                                        <p className="text-secondary small">2:14 pm</p>
                                    </div>
                                    <div className="col-auto">
                                        <a href="javascript:void(0)" className="btn btn-sm btn-square btn-link theme-red"><i className="bi bi-trash"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mb-2">
                    <div className="card-body">
                        <div className="row gx-3">
                            <div className="col-auto">
                                <figure className="avatar avatar-30 rounded-circle bg-theme-1 border border-theme-1">
                                    <p className="h6 fw-medium">JM</p>
                                </figure>
                            </div>
                            <div className="col">
                                <p className="small mb-2"><a href="adminux-profile-professional.html" className="text-theme-1 style-none">Jack Mario</a> commented: "This one is most usable design with great user experience. w..."</p>

                                <div className="row gx-3 align-items-center">
                                    <div className="col">
                                        <p className="text-secondary small">2 days ago</p>
                                    </div>
                                    <div className="col-auto">
                                        <a href="javascript:void(0)" className="btn btn-sm btn-square btn-link theme-red"><i className="bi bi-trash"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="alert alert-warning mb-2">
                    <div className="row gx-3">
                        <div className="col-auto">
                            <figure className="avatar avatar-30 rounded-circle bg-warning text-white">
                                <i className="bi bi-bell"></i>
                            </figure>
                        </div>
                        <div className="col">
                            <p className="small mb-2">Your subscription going to expire soon. Please <a href="adminux-subscription.html">upgrade</a> to get service interrupt free.</p>

                            <div className="row gx-3 align-items-center">
                                <div className="col">
                                    <p className="text-secondary small">4 days ago</p>
                                </div>
                                <div className="col-auto">
                                    <a href="javascript:void(0)" className="btn btn-sm btn-square btn-link theme-red"><i className="bi bi-trash"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mb-2">
                    <div className="card-body">
                        <div className="row gx-3">
                            <div className="col-auto">
                                <figure className="avatar avatar-30 coverimg rounded-circle">
                                    <img src={asset('assets/img/adminuiux/user-4.jpg')} alt="" />
                                </figure>
                            </div>
                            <div className="col">
                                <p className="small mb-2"><a href="adminux-invoice.html" className="text-theme-1 style-none">Roberto Carlos</a> has requested to send $120.00 money.</p>

                                <div className="row gx-3 align-items-center">
                                    <div className="col">
                                        <p className="text-secondary small">6 days ago</p>
                                    </div>
                                    <div className="col-auto">
                                        <a href="javascript:void(0)" className="btn btn-sm btn-square btn-link theme-red"><i className="bi bi-trash"></i></a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mb-2">
                    <div className="card-body">
                        <div className="row gx-3">
                            <div className="col-auto">
                                <figure className="avatar avatar-30 rounded-circle bg-theme-1-subtle text-theme-1 theme-orange">
                                    <i className="bi bi-calendar-event"></i>
                                </figure>
                            </div>
                            <div className="col">
                                <h6 className="mb-1">Adminuiux: #1 HTML Templates</h6>
                                <p className="small mb-2">Learning for better user experience on Universal app. development</p>
                                <div className="avatar-group mb-2">
                                    <figure className="avatar avatar-20 coverimg rounded-circle" data-bs-toggle="tooltip" title="Mickey">
                                        <img src={asset('assets/img/adminuiux/user-3.jpg')} alt="" />
                                    </figure>
                                    <figure className="avatar avatar-20 coverimg rounded-circle" data-bs-toggle="tooltip" title="Jacky">
                                        <img src={asset('assets/img/adminuiux/user-4.jpg')} alt="" />
                                    </figure>
                                    <div className="avatar avatar-20 bg-theme-1 rounded-circle">
                                        <small className="fs-10 vm">9+</small>
                                    </div>
                                    <span className="text-secondary small"> are attending</span>
                                </div>

                                <div className="row gx-3 align-items-center">
                                    <div className="col">
                                        <p className="text-secondary small">7 days ago</p>
                                    </div>
                                    <div className="col-auto">
                                        <a href="javascript:void(0)" className="btn btn-sm btn-square btn-link theme-red"><i className="bi bi-trash"></i></a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mb-2">
                    <div className="card-body">
                        <div className="row gx-3">
                            <div className="col-auto">
                                <figure className="avatar avatar-30 coverimg rounded-circle">
                                    <img src={asset('assets/img/adminuiux/user-3.jpg')} alt="" />
                                </figure>
                            </div>
                            <div className="col">
                                <p className="small mb-2"><a href="adminuiux-profile-professional.html" className="text-theme-1 style-none">The AdminUIUX</a> commented: "Thank you so much for this deep view at Adminuiux..."</p>

                                <div className="row gx-3 align-items-center">
                                    <div className="col">
                                        <p className="text-secondary small">1 year ago</p>
                                    </div>
                                    <div className="col-auto">
                                        <a href="javascript:void(0)" className="btn btn-sm btn-square btn-link theme-red"><i className="bi bi-trash"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Notification;
